import * as yup from "yup";
import {
  basicSchema,
  clientInfoAttributesSchema,
  createArchitecturalDesignWorkAttributesSchema,
  createContractorInfoAttributesSchema,
  detailSchema,
} from "../../../../shared/lib/businessMatchingFormUtils";

export const step1Schema = basicSchema.concat(
  yup.object().shape({
    email: yup.string().trim().email().required().label("メールアドレス"),
  }),
);

export const step2Schema = detailSchema.concat(
  yup.object({
    contractor_info_attributes: yup.lazy((_value, { parent }) => {
      const useCase = (parent as { use_case: string }).use_case;
      const checkIsContractor = () =>
        useCase === "contractor" || useCase === "both";
      return createContractorInfoAttributesSchema(checkIsContractor)
        .concat(
          yup.object({
            architectural_design_works_attributes: yup
              .array()
              .of(
                createArchitecturalDesignWorkAttributesSchema(
                  checkIsContractor,
                ),
              )
              .required()
              .ensure()
              .when({
                is: checkIsContractor,
                then: (schema) => schema.min(1),
              }),
          }),
        )
        .nullable()
        .when({
          is: checkIsContractor,
          then: (schema) => schema.required(),
        });
    }),
    client_info_attributes: clientInfoAttributesSchema,
  }),
);
